var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5C1.6875 1.52083 1.52083 1.6875 1.5 2V2.6875L6.90625 7.125C7.23958 7.375 7.60417 7.5 8 7.5C8.41667 7.5 8.79167 7.375 9.125 7.125L14.5 2.6875V2C14.4792 1.6875 14.3125 1.52083 14 1.5H2ZM1.5 4.625V10C1.52083 10.3125 1.6875 10.4792 2 10.5H14C14.3125 10.4792 14.4792 10.3125 14.5 10V4.625L10.0625 8.28125C9.4375 8.76042 8.75 9 8 9C7.25 9 6.5625 8.76042 5.9375 8.28125L1.5 4.625ZM0 2C0.0208333 1.4375 0.21875 0.96875 0.59375 0.59375C0.96875 0.21875 1.4375 0.0208333 2 0H14C14.5625 0.0208333 15.0312 0.21875 15.4062 0.59375C15.7812 0.96875 15.9792 1.4375 16 2V10C15.9792 10.5625 15.7812 11.0312 15.4062 11.4062C15.0312 11.7812 14.5625 11.9792 14 12H2C1.4375 11.9792 0.96875 11.7812 0.59375 11.4062C0.21875 11.0312 0.0208333 10.5625 0 10V2Z",
    fill: "#3C3C43",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.40899f39.svg";
export { ForwardRef as ReactComponent };